class HeaderSearch {
    constructor() {
        $(document).on('domReady', () => {
            return this.initSearch();
        });
    }

    initSearch() {
        this.searchPlaceholderEvents();
    }

    // Events to control placeholder visibility
    searchPlaceholderEvents() {
        // When the search button is clicked
        $('header .search button').click((e) => {
            // Check that the search box has nothing in it
            if ($('header .search input').val() !== '') {
                return;
            }
            // Prevent the form from submitting
            e.preventDefault();
            // If the placeholder is visible
            if (!$('header .search .placeholder').hasClass('hide-it')) {
                // Hide the placeholder
                this.hideSearchPlaceHolder();
            }
        });

        // When the user clicks out of the search box
        $('header .search input').blur((e) => {
            // Check that the search box has nothing in it
            if ($(e.currentTarget).val() === '') {
                // Hide the placeholder
                return this.showSearchPlaceHolder();
            }
        });

        // When the window regains focus
        $(window).focus(() => {
            // If the placeholder is visible
            if (!$('header .search .placeholder').hasClass('hide-it')) {
                // And if the input has focus
                if ($('header .search input').is(':focus')) {
                    // make sure the placeholder is hidden
                    this.hideSearchPlaceHolder();
                }
            }
        });

        // When the placeholder is clicked
        $('header .search .placeholder').click(() => {
            // Redirect click to focus the input and hide the placeholder
            this.hideSearchPlaceHolder();
        });
    }

    // Hides the placeholder
    hideSearchPlaceHolder() {
        $('header .search .placeholder').addClass('hide-it');
        $('header .search input').focus();
    }

    // Shows the placeholder
    showSearchPlaceHolder() {
        $('header .search .placeholder').removeClass('hide-it');
        // Prevent an infinite loop of badness
        if ($('header .search input').is(':focus')) {
            $('header .search input').blur();
        }
    }
}

export default new HeaderSearch();
